import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "help-slot-page" }
const _hoisted_2 = { class: "page-scroll-wrap with-header-bar no-nav-bar" }
const _hoisted_3 = { class: "top-banner" }
const _hoisted_4 = { class: "game-filter-wrap" }
const _hoisted_5 = { class: "game-search-wrap flex justify-between" }
const _hoisted_6 = { class: "sort-wrap flex justify-end" }
const _hoisted_7 = {
  key: 0,
  class: "provider-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "scroll-view with-provider" }
const _hoisted_10 = { class: "game-info-warp" }
const _hoisted_11 = { class: "game-title" }
const _hoisted_12 = { class: "progress-wrap flex" }
const _hoisted_13 = { class: "progress-value" }
const _hoisted_14 = { class: "game-meter" }
const _hoisted_15 = { class: "game-info-list" }
const _hoisted_16 = { class: "game-info-item" }
const _hoisted_17 = { class: "game-info-item" }
const _hoisted_18 = { class: "game-info-item" }
const _hoisted_19 = { class: "game-info-item" }
const _hoisted_20 = { key: 1 }

import { ref, reactive, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Rule from './components/Rule';
import { queryGameProvider, queryGame } from "@/api";
import { min } from 'moment/moment';


export default {
  __name: 'index',
  setup(__props) {

const themeVars = reactive({
  fieldPlaceholderTextColor: '#DADADA',
});

const route = useRoute();
const router = useRouter();

const providerList = ref([]);
const activeProvider = ref(null);
const searchText = ref('');
const sortType = ref('')
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const gameList = ref([]);
const dataList = ref([]);
const current = ref(1);
const pageSize = ref(20);
const timeFix = ref(0);
const showRule = ref(false);
const refreshInterval = ref(null);

watch(activeProvider, (newValue, oldValue) => {
  if(newValue) {
    reloadData();
  }
})

watch(sortType, (newValue, oldValue) => {
  processData();
})


onMounted(() => {
  if (route.query?.uid) {
    let uid = decodeURIComponent(decodeURIComponent(route.query?.uid));
    router.replace({ query: {} });
    setTimeout(() => {
      router.push({ name: 'userDetail', params: { uid } });
    }, 300)
  } else {
    fetchGameProvider();
    refreshInterval.value = setInterval(() => {
      processData();
    }, 2000)
  }
})


onUnmounted(() => {
  if(refreshInterval.value) {
    clearInterval(refreshInterval.value);
  }
})

const fetchGameProvider = () => {
  queryGameProvider({
    type: 'slot',
  }).then(res => {
    providerList.value = res.data || [];
    if (providerList.value.length > 0) {
      activeProvider.value = providerList.value[0]
    } else {
      activeProvider.value = null;
      refreshing .value= true;
      loadData();
    }
  });
}

const fetchGameList = () => {
  queryGame({
    type: 'slot',
    pageSize: pageSize.value,
    current: current.value,
    manuf: activeProvider.value?.code,
    keyword: searchText.value
  }).then(res => {
    const { data, sysTime, total, page } = res || {};
    let now = parseInt(new Date().getTime() / 1000);
    timeFix.value = sysTime - now;
    gameList.value = gameList.value.concat(data || []);
    processData();

    if (total <= page * pageSize.value) {
      finished.value = true;
    } else {
      current.value = page + 1;
    }
    loading.value = false;
  });
}

const loadData = () => {
  if (refreshing.value) {
    gameList.value = [];
    current.value = 1;
    refreshing.value = false;
  }
  fetchGameList();
}

const refreshData = () => {
  finished.value = false;
  loading.value = true;
  loadData();
}

const reloadData = () => {
  gameList.value = [];
  current.value = 1;
  loading.value = false;
  finished.value = false;
  refreshing.value = false;
  fetchGameList();
}

const processData = () => {
  let now = parseInt(new Date().getTime() / 1000);
  let newDataList = gameList.value.map(item => {
    let value = generateValue(now + timeFix.value, item.name);
    let up = true
    if (value > 90 && value <= 270) {
      up = false;
    }
    value = formatValue(value);
    let min10 = formatValue(generateValue(now + timeFix.value - 600, item.name));
    let hr1 = formatValue(generateValue(now + timeFix.value - 3600, item.name));
    let hr3 = formatValue(generateValue(now + timeFix.value - 10800, item.name));
    let hr6 = formatValue(generateValue(now + timeFix.value - 21600, item.name));
    
    return {
      ...item,
      up,
      value,
      min10: value.sub(min10),
      hr1: value.sub(hr1),
      hr3: value.sub(hr3),
      hr6: value.sub(hr6)
    }
  })

  if (sortType.value === 'asc') {
    dataList.value = newDataList.sort((a, b) => {
      if (!a.up && b.up) {
        return b.value - a.value + 9999
      } else if (a.up && !b.up) {
        return b.value - a.value - 9999
      } else {
        return b.value - a.value
      }
    });
  } else if(sortType.value === 'desc') {
    dataList.value = newDataList.sort((a, b) => {
      if (!a.up && b.up) {
        return a.value - b.value - 9999
      } else if (a.up && !b.up) {
        return a.value - b.value + 9999
      } else {
        return a.value - b.value
      }
    });
  } else {
    dataList.value = newDataList;
  }
}

const generateValue = (timestamp, name) => {
  // 使用时间戳和名称生成一个唯一的种子值
  const seedBase = parseInt((name).split('').reduce((acc, char) => acc + char.charCodeAt(0), 0));
  const seed = timestamp + seedBase;

  // 创建一个LCG实例
  const random = lcg(seed);

  let value = random() * 360; // 保证初始值在0-360之间
  return value;
}

const formatValue = value => {
  return parseFloat(((Math.sin(value * Math.PI / 180) + 1) * 40 + 10).toFixed(2));
}

const lcg = seed => {
  const m = 0x80000000; // 2**31
  const a = 3515245;
  const c = 12345;

  return function() {
    seed = (a * seed + c) % m;
    return seed / m;
  };
}

return (_ctx, _cache) => {
  const _component_HeaderBar = _resolveComponent("HeaderBar")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_search = _resolveComponent("van-search")
  const _component_van_config_provider = _resolveComponent("van-config-provider")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          class: "banner-img",
          src: require('@/assets/img/common/banner.png')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_config_provider, { "theme-vars": themeVars }, {
            default: _withCtx(() => [
              _createVNode(_component_van_search, {
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((searchText).value = $event)),
                placeholder: _ctx.$t('game.search'),
                "show-action": ""
              }, {
                action: _withCtx(() => [
                  _createElementVNode("div", { onClick: reloadData }, _toDisplayString(_ctx.$t('common.search')), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["theme-vars"]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_component_van_image, {
              class: "sort-icon",
              fit: "contain",
              src: require('@/assets/img/help-slot/up-large.png'),
              onClick: _cache[1] || (_cache[1] = $event => (sortType.value = sortType.value === 'asc' ? '' : 'asc'))
            }, null, 8, ["src"]), [
              [_directive_audio]
            ]),
            _withDirectives(_createVNode(_component_van_image, {
              class: "sort-icon",
              fit: "contain",
              src: require('@/assets/img/help-slot/down-large.png'),
              onClick: _cache[2] || (_cache[2] = $event => (sortType.value = sortType.value === 'desc' ? '' : 'desc'))
            }, null, 8, ["src"]), [
              [_directive_audio]
            ])
          ])
        ]),
        (providerList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providerList.value, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`provider-item ${activeProvider.value && activeProvider.value.code === item.code ? 'active' : 'inactive'}`),
                  key: item.id,
                  onClick: $event => (activeProvider.value = item)
                }, [
                  _createVNode(_component_van_image, {
                    class: "provider-icon",
                    fit: "contain",
                    src: item.logo
                  }, null, 8, ["src"])
                ], 10, _hoisted_8)), [
                  [_directive_audio]
                ])
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((refreshing).value = $event)),
          onRefresh: refreshData
        }, {
          default: _withCtx(() => [
            (dataList.value.length > 0)
              ? (_openBlock(), _createBlock(_component_van_list, {
                  key: 0,
                  loading: loading.value,
                  "onUpdate:loading": _cache[3] || (_cache[3] = $event => ((loading).value = $event)),
                  class: "game-list",
                  finished: finished.value,
                  "finished-text": _ctx.$t('common.noMore'),
                  onLoad: loadData
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["game-block flex", {'up': !!item.up }]),
                        key: item.id
                      }, [
                        _createVNode(_component_van_image, {
                          class: "game-img",
                          fit: "cover",
                          src: item.logo || '-',
                          "error-icon": require('@/assets/img/help-slot/game.png')
                        }, {
                          loading: _withCtx(() => [
                            _createVNode(_component_van_loading, {
                              type: "spinner",
                              color: "#ADB5BF",
                              size: "24"
                            })
                          ]),
                          _: 2
                        }, 1032, ["src", "error-icon"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`progress-bar-wrap flex ${item.up ? 'up' : 'down'}`)
                            }, [
                              _createElementVNode("div", {
                                class: "progress-bar",
                                style: _normalizeStyle(`width: ${item.value}%`)
                              }, null, 4),
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "progress-bar-border" }, null, -1)),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(item.value) + "%", 1)
                            ], 2),
                            (item.up)
                              ? (_openBlock(), _createBlock(_component_van_image, {
                                  key: 0,
                                  class: "status-icon",
                                  fit: "contain",
                                  src: require('@/assets/img/help-slot/up.png')
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock(_component_van_image, {
                                  key: 1,
                                  class: "status-icon",
                                  fit: "contain",
                                  src: require('@/assets/img/help-slot/down.png')
                                }, null, 8, ["src"]))
                          ]),
                          _createElementVNode("div", _hoisted_14, "Jackpot Meter: " + _toDisplayString(item.value) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "game-info-label" }, "10min:", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["game-info-value", item.min10 > 0 ? 'green' : 'red'])
                            }, _toDisplayString(item.min10) + "%", 3)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "game-info-label" }, "1 Hr:", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["game-info-value", item.hr1 > 0 ? 'green' : 'red'])
                            }, _toDisplayString(item.hr1) + "%", 3)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "game-info-label" }, "3 Hrs:", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["game-info-value", item.hr3 > 0 ? 'green' : 'red'])
                            }, _toDisplayString(item.hr3) + "%", 3)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "game-info-label" }, "6 Hrs:", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["game-info-value", item.hr6 > 0 ? 'green' : 'red'])
                            }, _toDisplayString(item.hr6) + "%", 3)
                          ])
                        ])
                      ], 2))
                    }), 128)),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "blank-block" }, null, -1))
                  ]),
                  _: 1,
                  __: [11]
                }, 8, ["loading", "finished", "finished-text"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_van_empty, {
                    description: _ctx.$t('common.noData')
                  }, null, 8, ["description"])
                ]))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "tabbar-height" }, null, -1))
      ])
    ]),
    (showRule.value)
      ? (_openBlock(), _createBlock(_unref(Rule), {
          key: 0,
          onOnClose: _cache[5] || (_cache[5] = $event => (showRule.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}